import styled from 'styled-components';
import DesktopLayout from '../layouts/DesktopLayout';
import MobileLayout from '../layouts/MobileLayout';
import SocialMediaLink from '../components/SocialMediaLink';

const Contact = () => {
	return (
		<>
			<DesktopLayout content={<DesktopContent />} />
			<MobileLayout content={<MobileContent />} />
		</>
	);
};

export default Contact;

/************************************************************* DESKTOP MODE ****************************************************************************/

export const DesktopContent = () => {
	return (
		<DesktopDiv>
			<div className='links-container'>
				<h3>Get In Touch</h3>
				<a
					className='social-media-link'
					href='https://www.instagram.com/fuelledfitness.ca/'
					target='_blank'
					rel='noreferrer'>
					<SocialMediaLink
						type='instagram'
						size='50px'
						hover='black'
					/>
					<div className='link-text'>Instagram</div>
				</a>
				<a
					className='social-media-link'
					href='https://www.linkedin.com/company/fuelled-fitness'
					target='_blank'
					rel='noreferrer'>
					<SocialMediaLink
						type='linkedin'
						size='50px'
						hover='black'
					/>
					<div className='link-text'>LinkedIn</div>
				</a>
				<a
					className='social-media-link'
					href='mailto:krystin@fuelledfitness.ca'
					target='_blank'
					rel='noreferrer'>
					<SocialMediaLink
						type='email'
						size='50px'
						hover='black'
					/>
					<div
						className='link-text'
						style={{ fontSize: 'large' }}>
						krystin@fuelledfitness.ca
					</div>
				</a>
			</div>
		</DesktopDiv>
	);
};

export const DesktopDiv = styled.div`
	width: 100%;
	max-width: 1500px;
	height: calc(100vh - 120px);
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;

	& > .links-container {
		position: relative;
		max-width: 100%;
		width: auto;
		margin-top: 50px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		& > h3 {
			width: 100%;
			text-align: center;
			font-size: xx-large;
			font-weight: bold;
			margin: 0 0 1ch;
			padding: 0;
		}

		& > .social-media-link {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: start;
			margin-bottom: 10px;
			color: inherit;
			text-decoration: none;
			gap: 10px;

			& > .link-text {
				display: flex;
				width: auto;
				justify-content: center;
				align-items: center;
				font-size: x-large;
				text-align: center;
				font-weight: bold;
				position: relative;

				&::after {
					content: '';
					position: absolute;
					height: 3px;
					width: 0;
					left: 50%;
					bottom: 0;
					background: #3498db;
					box-shadow: 0 0 8px 2px rgba(52, 152, 219, 0.6);
					transition: all 0.3s ease;
					transform: translateX(-50%);
				}

				&:hover::after {
					width: 100%;
				}
			}
		}
	}
`;

/************************************************************* MOBILE MODE ****************************************************************************/

export const MobileContent = () => {
	return (
		<MobileDiv>
			<div className='links-container'>
				<h2>Get In Touch</h2>
				<div className='social-media-links'>
					<a
						className='link'
						href='https://www.instagram.com/fuelledfitness.ca/'
						target='_blank'
						rel='noreferrer'>
						<SocialMediaLink
							type='instagram'
							size='50px'
							hover='black'
						/>
						<span className='link-text'>Instagram</span>
					</a>
					<a
						className='link'
						href='https://www.linkedin.com/company/fuelled-fitness'
						target='_blank'
						rel='noreferrer'>
						<SocialMediaLink
							type='linkedin'
							size='50px'
							hover='black'
						/>
						<span className='link-text'>LinkedIn</span>
					</a>
					<a
						className='link'
						href='mailto:krystin@fuelledfitness.ca'
						target='_blank'
						rel='noreferrer'>
						<SocialMediaLink
							type='email'
							size='50px'
							hover='black'
						/>
						<span
							className='link-text'
							style={{ fontSize: 'large' }}>
							krystin@fuelledfitness.ca
						</span>
					</a>
				</div>
			</div>
		</MobileDiv>
	);
};

export const MobileDiv = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;

	& > .links-container {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: start;
		align-items: center;
		margin: 10px 0;

		& > h2 {
			width: 100%;
			margin: 1ch 0;
			text-align: center;
			font-size: xx-large;
		}

		& > .social-media-links {
			width: max-content;
			max-width: 95%;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
			gap: 10px;

			& > .link {
				width: 100%;
				display: flex;
				flex-direction: row;
				justify-content: flex-start;
				gap: 10px;
				align-items: center;
				color: inherit;
				text-decoration: none;

				& > .link-text {
					font-size: x-large;
					font-weight: bold;
				}
			}
		}
	}
`;
